/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { Theme } from "@mui/material/styles";
import { useMaterialUIController } from "context/ThemeContext";

const useDarkMode = () => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  return darkMode;
};

// sidenav type buttons styles
export const sidenavTypeButtonsStyles = ({
  functions: { pxToRem },
  palette: { white, dark, background },
  borders: { borderWidth },
}: Theme | any) => ({
  height: pxToRem(39),
  background: useDarkMode ? background.sidenav : white.main,
  color: useDarkMode ? white.main : dark.main,
  border: `${borderWidth[1]} solid ${useDarkMode ? white.main : dark.main}`,

  "&:hover, &:focus, &:focus:not(:hover)": {
    background: useDarkMode ? background.sidenav : white.main,
    color: useDarkMode ? white.main : dark.main,
    border: `${borderWidth[1]} solid ${useDarkMode ? white.main : dark.main}`,
  },
});

// sidenav type active button styles
export const sidenavTypeActiveButtonStyles = ({
  functions: { pxToRem, linearGradient },
  palette: { white, dark, gradients, background },
}: Theme | any) => ({
  height: pxToRem(39),
  background: useDarkMode ? white.main : linearGradient(gradients.dark.main, gradients.dark.state),
  color: useDarkMode ? dark.main : white.main,

  "&:hover, &:focus, &:focus:not(:hover)": {
    background: useDarkMode
      ? white.main
      : linearGradient(gradients.dark.main, gradients.dark.state),
    color: useDarkMode ? dark.main : white.main,
  },
});

